import { SearchInputFilterItems } from "features/filters/components";

import type { FacetParam, SelectedFacetParam } from "common/types";

import useListLeadsParams from "../../../../hooks/useListLeadsParams";

import type { ListLeadsFacets, ListLeadsSearchParams } from "../../../../types";

interface FilterOptionsProps {
  filterKey: keyof Omit<ListLeadsSearchParams<never>, "keyword">;
  searchParams: ListLeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: ListLeadsSearchParams<SelectedFacetParam>,
  ) => void;
  facets: ListLeadsFacets;
  isLoadingFacets: boolean;
}

export default function FilterOptions({
  filterKey,
  searchParams,
  setSearchParams,
  facets,
  isLoadingFacets,
}: FilterOptionsProps) {
  const { toggleSearchParam, setSearchParam } = useListLeadsParams(
    searchParams,
    setSearchParams,
  );

  //the api can return empty ids, which have nothing to filter by
  const facetOptions = facets?.[filterKey]?.filter(({ id }) => !!id) ?? [];

  return (
    <SearchInputFilterItems<FacetParam>
      isLoading={isLoadingFacets}
      getFilteredItems={(lowercaseSearchKeyword) =>
        facetOptions.filter(({ name }) =>
          name.toLowerCase().includes(lowercaseSearchKeyword),
        )
      }
      getIsChecked={({ id }) =>
        searchParams[filterKey].some((facet) => facet.id === id)
      }
      onSelectionChange={(type, item) => {
        if (type === "toggle") {
          toggleSearchParam(filterKey, item);
        } else {
          setSearchParam(filterKey, [{ id: item.id, name: item.name }]);
        }
      }}
      itemCountKey="target_count"
      renderLabel={({ name }) => name}
    />
  );
}
